export default {"src":"/_next/static/media/arrow-gray-new.72d6b4c7.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};